import styled from 'styled-components';

export const DEFAULT_SIDE_PANEL_WIDTH = 'clamp(20rem, 24vw, 28.75rem)';

interface ContainerProps {
	$withBorder: boolean;
	$minWidth?: string;
}

export const DetailsPanelsContainer = styled.div<ContainerProps>`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	min-width: ${({ $minWidth }) => $minWidth ?? 'auto'};
	overflow: hidden;

	${({ $withBorder, theme }) =>
		$withBorder
			? `border: 1px solid ${theme.v3.colors.gray[4]};
			   border-radius: 0.25rem;`
			: ''}
`;

export const DetailsPanelsRow = styled.div`
	display: flex;
	flex: 1;
	min-height: 0;
	overflow: hidden;
`;

interface PanelProps {
	$width: string;
	$side: 'leading' | 'trailing';
}

// A side panel keeps its width and scrolls internally, so the main region is the only
// part that reflows as content changes.
export const DetailsSidePanelContainer = styled.aside<PanelProps>`
	flex: 0 0 ${({ $width }) => $width};
	min-width: 0;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	${({ $side, theme }) =>
		$side === 'leading'
			? `border-right: 1px solid ${theme.v3.colors.gray[4]};`
			: `border-left: 1px solid ${theme.v3.colors.gray[4]};`}
`;

export const DetailsMainPanel = styled.section`
	flex: 1 1 auto;
	min-width: 0;
	min-height: 0;
	overflow: auto;
	position: relative;
`;

export const DetailsPanelsFooter = styled.div`
	flex-shrink: 0;
	border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
`;
